<template>
  <div class="left">
    <div class="nav">
      <ul>
        <li :class="{'on':selectOperator}"><router-link to="/operator">运维</router-link></li>
        <li><router-link to="/device">设备</router-link></li>
        <li :class="{'on':selectCustomer}"><router-link to="/customer">客户</router-link></li>
        <li><router-link to="/devicetype">型号</router-link></li>
       <!-- <li><router-link to="/setting">设置</router-link></li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Left',
  data () {
    return {
       selectCustomer:false,
       selectOperator:false,
    }
  },
  watch:{
    $route(to,from){
      if(to.path=='/customerDevice'){
        this.selectCustomer=true
      }else{
        this.selectCustomer=false
      }
      if(to.path=='/operatorDevice'){
        this.selectOperator=true
      }else{
        this.selectOperator=false
      }


    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .nav {padding-top:50px;}
   .nav ul li {height:50px;line-height:50px;}
   .nav a {padding-left:30px;display: block;}
   .nav .router-link-exact-active {color:#357af1;background:#f1f4ff;padding-left:27px;border-left:#357af1 3px solid;}
   .nav ul li.on a {color:#357af1;background:#f1f4ff;padding-left:27px;border-left:#357af1 3px solid;}
</style>



// WEBPACK FOOTER //
// src/components/Left.vue